<template>
  <div>
    <!-- 목록 (table4) -->
    <div :class="['scpm_table', { 'custom-height-modify-table': mode === 'modify' }]">
      <lego-paging-table
        ref="table"
        :multiSelect="!readonly"
        :selectAll="!readonly"
        tableFixed
        isNotScrollX
        v-model="selected"
        :items="valueTmp2"
        :headers="recipientHeaders"
        :noDataText="t(mode === 'modify' ? 'page.eventStatus.noticeNoTarget' : 'label.noData')"
        :selectActionControl="false"
        :scrollMaxRow="scrollMaxRow"
        :noPage="true"
        @sort="onInnerTableSortChange"
      >
        <template #counter-instead>
          <div class="left-con">
            <span class="subtitle">
              {{ t('page.eventStatus.notificationInforTotal') }}
              <!--알림정보 총-->
              <span class="lego-table__counter__total">
                <b>{{ totalCount }}</b>
              </span>
              {{ t('page.eventStatus.case') }}
              <!--건-->
            </span>
          </div>
        </template>

        <template #extra-action>
          <lego-button v-if="mode === 'modify'" @click="openAddUserModal"
            >{{ t('button.notify') }}
          </lego-button>
          <!--추가-->
          <!-- <lego-button v-if="!readonly" @click="removeItem" :disabled="chkDeleteBtn">{{
              t('button.remove')
            }}
          </lego-button> -->
          <!--삭제-->
        </template>
      </lego-paging-table>
    </div>
    <AddUserModal
      v-if="showAddUserModal"
      :alarmInfos="valueTmp2"
      :rules="rules"
      @close:modal="closeAddUserModal"
      @userSelected="userSelected"
      :isEventSetting="true"
    />
  </div>
</template>
<script>
import AddUserModal from '../../alarmAddrs/AddUserModal';
import i18nMixin from '@/mixins/i18n.mixin.js';
import _ from 'lodash';
import { useAdditionalInfo } from '@/composables/addressBook/useAdditionalInfo.js';

const { getUserName } = useAdditionalInfo();

export default {
  mixins: [i18nMixin],
  emits: ['change-data', 'confirmModifyInfo'],
  watch: {
    selected: {
      deep: true,
      handler() {
        //alert(this.selected.length);
        this.chkDeleteBtn = this.selected.length <= 0;
      },
      immediate: true
    },
    valueTmp: {
      handler(newValue) {
        this.valueTmp2 = newValue;
      },
      immediate: false,
      deep: true
    },
    valueTmp2: {
      handler(v) {
        if (!this.readonly) {
          if (!_.isEqual(v, this.valueTmp)) {
            this.$emit('change-data');
          }
        }
      },
      immediate: false,
      deep: true
    }
  },
  props: {
    scrollMaxRow: {
      type: Number,
      default: 10
    },
    valueTmp: {
      type: Array,
      default: () => {
        return [];
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => {
        return [];
      }
    },
    userName: {
      type: String
    },
    mode: {
      type: String,
      default: 'view'
    }
  },
  components: {
    AddUserModal
  },
  provide() {
    return {
      clickAction: this.selectMethod
    };
  },
  computed: {
    eventLevelSet() {
      //console.log('eventLevelSet = 111 ', this.rules);
      let result = [];
      if (this.rules) {
        const eventLevels = ['FATAL', 'WARNING', 'INFORM'];
        eventLevels.forEach((eventLevel) => {
          let event = this.rules.find((item) => item.eventLevel == eventLevel);
          //console.log('eventLevelSet = 2222 event = ' + event);
          if (event != null) {
            result.push(eventLevel);
          }
        });
      }

      return result;
    },
    totalCount() {
      return this.valueTmp2.length;
    }
  },
  created() {
    this.valueTmp2.forEach((item) => {
      const eventLevels = ['FATAL', 'WARNING', 'INFORM'];
      eventLevels.forEach((eventLevel) => {
        if (
          this.$util.isEmpty(item.notificationMethods.find((item) => item.eventLevel == eventLevel))
        ) {
          item.notificationMethods.push({ eventLevel: eventLevel, sendMethod: ['MAIL'] });
        }
      });
    });
    this.notificationList = this.$util.deepCopy(this.valueTmp2);
    this.chkDeleteBtn = true;
  },
  data() {
    return {
      valueTmp2: this.valueTmp,
      showAddUserModal: false,
      selected: [],
      recipientHeaders: [
        {
          text: this.$t('page.eventStatus.notificationTargetGroup'), //알림대상자 / 그룹
          value: 'name',
          width: 560,
          minWidth: 200,
          sortable: false,
          defaultValue: '-',
          customCell: this.nameCell()
        },
        {
          text: this.$t('page.eventStatus.eventRisk'), // 이벤트 위험도
          value: 'eventLevel',
          width: 340,
          sortable: false,
          customCell: () => {
            return this.$util.getEventLevel(this.eventLevelSet);
          }
        },
        {
          text: this.$t('page.eventStatus.notificationMethod'), // 알림방식
          value: 'sendMethod',
          width: 440,
          minWidth: 350,
          customCell: this.methodSelecteCell
        }
      ],
      notificationList: [],
      chkDeleteBtn: true
    };
  },
  methods: {
    removeItem() {
      if (this.valueTmp2.length > 0) {
        this.$modal.open({
          type: 'confirm',
          title: this.t('page.eventStatus.notice'),
          message: this.$t('page.eventStatus.deleteItem', [this.selected.length]),
          cancel: () => {
            //console.log('cancel');
          },
          action: () => {
            this.selected.forEach((item) => {
              const index = this.valueTmp2.indexOf(item);
              this.valueTmp2.splice(index, 1);
            });
            this.notificationList = this.$util.deepCopy(this.valueTmp2);
            this.$emit('change-data');
            this.selected = [];
          }
        });
      }
    },
    nameCell() {
      return {
        props: {
          item: {
            type: Object,
            default: {}
          }
        },
        computed: {
          isUser() {
            return this.item.recipientType === 'USER';
          },
          emptyData() {
            return !this.item.userAdditionalInfo && !this.item.addrbookAdditionalInfo;
          },
          content() {
            if (this.emptyData) return this.$t('label.deletedUser');

            if (this.isUser) {
              return `${this.item.recipientName} (${
                this.item.userAdditionalInfo.email || this.item.userAdditionalInfo.userEmail || '-'
              }) / ${this.$t('page.eventStatus.defaultGroup')}`;
            }

            let userGroup = `${this.removeDoubleQuotation(this.item.recipientName)} (${getUserName(
              this.item
            )}`;

            if (this.item.addrbookAdditionalInfo.memberCount > 1) {
              userGroup += ` ${this.$t('label.otherOfPerson', [
                this.item.addrbookAdditionalInfo.memberCount - 1
              ])}`;
            }
            userGroup += ')';

            return userGroup;
          }
        },
        methods: {
          removeDoubleQuotation(value) {
            return value.replace(/["']/g, '');
          }
        },
        template: `
          <div v-if="emptyData || isUser" class="ellipsis" v-lego-tooltip:ellipsis="content">{{ content }}</div>
          <div v-else style="display:flex; align-items: center;"><div class="ellipsis" v-lego-tooltip="$t('page.alarmGroup.alarmGroup')" style="margin-right: 3px; flex: 0 0 auto; width: 20px" v-html="$util.dangerIcon('G','G')"></div><div class="ellipsis" v-lego-tooltip:ellipsis="content">{{ content }}</div></div>
        `
      };
    },
    selectMethod(seq, index, eventLevel, type) {
      this.$emit('change-data');
      let notificationMethod = this.valueTmp2[index].notificationMethods.find(
        (item) => item.eventLevel == eventLevel
      );

      //console.log('notificationMethod = ', notificationMethod);
      if (notificationMethod != null && notificationMethod.sendMethod != null) {
        if (notificationMethod.sendMethod.includes(type)) {
          let i = notificationMethod.sendMethod.indexOf(type);
          notificationMethod.sendMethod.splice(i, 1);
        } else {
          notificationMethod.sendMethod.push(type);
        }
      }

      this.notificationList = this.$util.deepCopy(this.valueTmp2);
      this.$refs.table.$forceUpdate();
    },
    methodSelecteCell(value, index, item) {
      //console.log('eventLevelSet = ', this.eventLevelSet);
      let result = `<div style="margin-top:5px;line-height:29px">`;
      if (this.eventLevelSet.includes('FATAL'))
        result += `<ScpmMethodSelect :seq="'${
          item.seq
        }'" :index="${index}" :eventLevel="'FATAL'" :sendMethod="'${this.getSendMethod(
          item,
          'FATAL'
        )}'" :readonly="${this.readonly}"/>`;
      if (this.eventLevelSet.includes('WARNING'))
        result += `<ScpmMethodSelect :seq="'${
          item.seq
        }'" :index="${index}" :eventLevel="'WARNING'" :sendMethod="'${this.getSendMethod(
          item,
          'WARNING'
        )}'" :readonly="${this.readonly}"/>`;
      if (this.eventLevelSet.includes('INFORM'))
        result += `<ScpmMethodSelect :seq="'${
          item.seq
        }'" :index="${index}" :eventLevel="'INFORM'" :sendMethod="'${this.getSendMethod(
          item,
          'INFORM'
        )}'" :readonly="${this.readonly}"/>`;

      result += `</div>`;
      return result;
      // return `<div style="margin-top:8px">
      // <ScpmMethodSelect :seq="${item.seq}" :index="${index}" :eventLevel="'FATAL'" :email="${item.FATAL.email}" :sms="${item.FATAL.sms}" :messenger="${item.FATAL.messenger}"/>
      // <ScpmMethodSelect :seq="${item.seq}" :index="${index}" :eventLevel="'WARNING'" :email="${item.WARNING.email}" :sms="${item.WARNING.sms}" :messenger="${item.WARNING.messenger}"/>
      // <ScpmMethodSelect :seq="${item.seq}" :index="${index}" :eventLevel="'INFORM'" :email="${item.INFORM.email}" :sms="${item.INFORM.sms}" :messenger="${item.INFORM.messenger}"/>
      // </div>`;
    },
    getSendMethod(item, eventLevel) {
      let notification = item.notificationMethods.find((item) => item.eventLevel == eventLevel);
      if (this.$util.isEmpty(notification)) {
        return ['MAIL', 'SMS', 'MESSENGER'];
      } else {
        return notification.sendMethod;
      }
    },
    openAddUserModal() {
      this.showAddUserModal = true;
    },
    closeAddUserModal() {
      this.showAddUserModal = false;
    },
    userSelected(recipients) {
      this.$emit('confirmModifyInfo', recipients);
    },

    onInnerTableSortChange(header) {
      if (header.text === this.$t('page.eventStatus.notificationTargetGroup')) {
        this.valueTmp2 = this.$util.customSort(
          this.valueTmp2,
          'recipientName',
          header.asc ? 'asc' : 'desc'
        );
        return;
      }
      if (this.valueTmp2) {
        this.valueTmp2.sort((a, b) => this.innerTableCompare(a, b, header));
      }
    },
    innerTableCompare(a, b, header) {
      let first = '';
      let second = '';
      let func;
      const c = header.asc ? 1 : -1;
      switch (header.text) {
        case this.$t('page.eventStatus.eventRisk'): //'이벤트 위험도'
          func = function (value) {
            return (
              value.notificationMethods[0].eventLevel +
              value.notificationMethods[1].eventLevel +
              value.notificationMethods[2].eventLevel
            );
          };
          break;
        case this.$t('page.eventStatus.notificationMethod'): //'알림방식'
          func = function (value) {
            return (
              value.notificationMethods[0].sendMethod +
              value.notificationMethods[1].sendMethod +
              value.notificationMethods[2].sendMethod
            );
          };
          break;
      }
      [first, second] = [a, b].map((value) => func(value));
      return ((first > second) - (second > first)) * c;
    }
  }
};
</script>
<style lang="scss" scoped>
.subtitle {
  padding: 10px 0 0 0;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
}

.table-header-wrap {
  padding-bottom: 10px;

  &:after {
    content: '';
    clear: both;
    display: table;
  }

  & .left-con {
    float: left;
    width: 40%;
  }

  & .right-con {
    float: right;
    width: 60%;
    text-align: right;
  }
}
.custom-height-modify-table {
  :deep(.lego-table__area-wrapper) {
    height: 187px;
    .set-scroll {
      max-height: 185px !important;
      .lego-table__area {
        background-color: #fff;
      }
    }
  }
}
</style>
